import { CUSTOMER_LEVEL } from '@wyz/types';
import { Navigate } from 'react-router';
import { RequiredCustomerWarning } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';

export default function WcwCustomerProtected({
  component: Component,
}: {
  component: React.ComponentType;
}) {
  const { state } = usePurchaseContext();

  if (
    state.targetCustomer?.level &&
    state.targetCustomer.level >= CUSTOMER_LEVEL.N2
  ) {
    return <Navigate to='/purchase' replace />;
  }

  if (!state.targetCustomer?.wcwSearchable) {
    return <RequiredCustomerWarning />;
  }

  return <Component />;
}
